import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import TariffsSection from "../../components/pages/home/tariffs-sections/TariffsSection";
import styles from "./Tariffs.module.scss";

const Tariffs = () => {
  return (
    <div id={styles.tariffs_page}>
      <TariffsSection enableUrlSync />
      <MobileAppSection />
    </div>
  );
};

export default Tariffs;
